import React from 'react';

// The 14px download tray, matching the glyph the chart card headers already
// use, so every CSV control in the app reads as the same affordance.
// `done` swaps it for a green check during the caller's confirmation window.
export function CsvDownloadIcon({ done }) {
  if (done) {
    return (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22c55e"
           strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    );
  }
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  );
}

// Icon-only CSV control. The label never renders as text — it becomes both the
// tooltip and the accessible name, which is the whole point of dropping the
// visible text: the button still announces itself to a screen reader and on
// hover, it just stops taking up a button's worth of room.
//
// Renders an <a> when `href` is set (a straight server-side download, where the
// browser needs a real link) and a <button> otherwise. An <a> has no disabled
// state, so callers that need one pass an onClick handler instead.
export default function IconCsvButton({ label, done, doneLabel = 'Downloaded', href, onClick, disabled }) {
  // aria-live on a wrapper would announce every hover; the label swap alone is
  // enough, since the check is a confirmation of an action the user just took.
  const shown = done ? doneLabel : label;
  const props = { className: 'icon-btn', title: shown, 'aria-label': shown };

  if (href) {
    return (
      <a {...props} href={href} onClick={onClick}>
        <CsvDownloadIcon done={done} />
      </a>
    );
  }
  return (
    <button {...props} type="button" onClick={onClick} disabled={disabled}>
      <CsvDownloadIcon done={done} />
    </button>
  );
}
